// extracted by mini-css-extract-plugin
export var deleteModal = "_hr-0";